import React from 'react'
import { TextField } from '@material-ui/core'

const SearchField = ({ value, onChange, placeholder, onClear }) => {
  const showClear = onClear && { endAdornment: <span className="fas fa-times onClick={onClear}" /> }
  return (
    <TextField
      variant="standard"
      className="mui-search custom-searchfield"
      label={null}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      InputProps={{ ...showClear, disableUnderline: true, startAdornment: <span className="fas fa-search" /> }}
    />
  )
}
export default SearchField
